import { z } from "zod";

export interface Post {
  content: string;
  metadata: {
    title: string;
    date: string;
    description: string;
  };
  slug: string;
}

export async function fetchPost(slug: string): Promise<Post> {
  const response = await fetch(`/posts/${slug}.md`);
  const text = await response.text();
  const [meta, content] = text.split("---\n").slice(1);
  const metadata = z
    .object({
      title: z.string(),
      date: z.string(),
      description: z.string(),
    })
    .parse(
      meta?.split("\n").reduce(
        (acc, line) => {
          const [key, value] = line.split(":").map((str) => str.trim());
          if (key && value) acc[key] = value.replace(/"/g, "");
          return acc;
        },
        {} as Record<string, string>,
      ),
    );

  return { content: content ?? "", metadata, slug };
}

export async function fetchAllPosts(): Promise<Post[]> {
  const slugs = [
    "qr-code-menus-future-dining",
    "interactive-qr-code-menus",
    "create-interactive-qr-code-menus",
    "boost-social-media-with-qr-menus",
    "eco-friendly-qr-code-menus",
    "qr-code-menus-customer-satisfaction",
    "qr-code-menus-branding-strategy",
    "qr-code-menus-post-pandemic",
    "seamless-dining-qr-menus",
    "future-trends-digital-dining-qr-menus",
    "embracing-future-qr-menus-for-restaurants",
  ];

  return Promise.all(slugs.map(fetchPost));
}
